import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import axios from "@/utils/axios";
export default new Vuex.Store({
  state: {
    platformName: '',
    isShowI18n: false,
    platformEnglishName: '',
    currentLang: '',
  },
  mutations: {
    //
  },
  actions: {
    getLoginInfo() {
      return new Promise((resolve, reject) => {
        try {
          axios.get("about/version").then(res => {
            if (res.data.success) {
              resolve(res.data);
            }
          }).catch(e => {
            reject(e);
          })
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  modules: {}
});